<template>

    <!-- Header 1 -->
    <div class="w-full fixed z-50">
        <div class="w-full bg-primary">
            <div class="w-full lg:max-w-screen-2xl py-4 px-4 lg:px-2 lg:mx-auto">
                <div class="flex justify-between items-center">
                    <!-- Logo -->
                    <div class="w-1/5 lg:w-1/12">
                        <div class="w-4/5">
                            <Logo></Logo>
                        </div>
                    </div>

                    <!-- Mobile Menu Button -->
                    <div class="lg:hidden" v-if="isAdminRoute">
                        <button @click="toggleMobileMenu"
                            class="text-white hover:text-gray-200 transition-colors duration-200">
                            <svg v-if="!showMobileMenu" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                            </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                stroke-width="2" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Desktop SubHeader -->

        <div :class="['bg-secondary w-full', { 'hidden lg:block': isAdminRoute }]">
            <div
                class="w-full lg:max-w-screen-2xl py-4 px-4 lg:px-5 lg:mx-auto flex justify-between items-center text-xs lg:text-sm">
                <!-- Language Switch -->
                <div class="lg:w-2/12 text-primary flex justify-start items-center space-x-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.85"
                        stroke="currentColor" class="w-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
                    </svg>

                    <div class="text-black flex space-x-1">
                        <div class="hover:text-primary hover:underline hover:scale-110 transition duration-200 cursor-pointer"
                            @click="switchLocale('ar')">
                            العربية
                        </div>
                        <div>|</div>
                        <div class="hover:text-primary hover:underline hover:scale-110 transition duration-200 cursor-pointer"
                            @click="switchLocale('fr')">
                            Français
                        </div>
                    </div>
                </div>

                <!-- Delete Info (only on edit-info route) -->
                <div v-if="route.name === 'edit-info'" @click="$emit('DeleteInfo')"
                    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                    class="flex items-center space-x-2 cursor-pointer hover:scale-105 transition duration-200">
                    <div class="text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-6">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                        </svg>
                    </div>
                    <div>{{ $t('deleteInfo') }}</div>
                </div>

                <!-- Admin Menu -->
                <div v-if="isAdminRoute" class="flex items-center space-x-3">
                    <!-- Logout -->
                   

                    <!-- Edit Admin -->
                    <div v-if="route.name !== 'admin-edit'" @click="router.push('/admin/edit')"
                        class="flex items-center space-x-2 cursor-pointer hover:scale-105 transition duration-200">
                        <div>{{ $t('admin_edit.menu_item') }}</div>
                        <div class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                            </svg>
                        </div>
                    </div>

                    <!-- Dashboard -->
                    <div v-if="route.name !== 'adminDashboard'" @click="router.push('/admin/dashboard')"
                        class="flex items-center space-x-2 cursor-pointer hover:scale-105 transition duration-200">
                        <div>{{ $t('admin_dashboard.title') }}</div>
                        <div class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                            </svg>
                        </div>
                    </div>

                    <!-- Super Admin -->
                    <div v-if="adminStore.type === 's-admin' && route.name !== 'adminsList'"
                        @click="router.push('/admin/list')"
                        class="flex items-center space-x-2 cursor-pointer hover:scale-105 transition duration-200">
                        <div>{{ $t('admin_create.admin_list') }}</div>
                        <div class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                            </svg>
                        </div>
                    </div>

                     <div @click="Logout"
                        class="flex items-center space-x-2 cursor-pointer hover:scale-105 transition duration-200">
                        <div>{{ $t('admin.logout') }}</div>
                        <div class="text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-6">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                            </svg>
                        </div>
                    </div>
                </div>

                <!-- Public Login link -->
                <div v-if="['inscription', 'home'].includes(route.name)"
                    class="flex items-center space-x-2 text-black text-xs lg:text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75"
                        stroke="currentColor" class="w-6 text-primary">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
                    </svg>
                    <span class="cursor-pointer" @click="router.push('/login')">
                        {{ $t('loginMsg') }}
                    </span>
                </div>
            </div>
        </div>
        <!-- Mobile Menu Overlay -->
        <div v-if="showMobileMenu && isAdminRoute" class="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
            @click="toggleMobileMenu">
        </div>

        <!-- Mobile Menu Slide Panel -->
        <div :class="[
            'lg:hidden fixed top-0 right-0 h-full w-80 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50',
            showMobileMenu ? 'translate-x-0' : 'translate-x-full'
        ]">

            <!-- Mobile Menu Header -->
            <div class="bg-primary p-4 flex justify-between items-center">
                <div class="text-white font-semibold text-lg">Menu</div>
                <button @click="toggleMobileMenu" class="text-white hover:text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                        stroke="currentColor" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

            <!-- Mobile Menu Content -->
            <div class="p-6 space-y-6">

                <!-- Language Switcher -->
                <div class="border-b border-gray-200 pb-4">
                    <div class="flex items-center space-x-2 mb-3">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.85"
                            stroke="currentColor" class="w-5 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
                        </svg>

                    </div>
                    <div class="flex flex-col space-y-2">
                        <button @click="switchLocale('ar'); toggleMobileMenu()"
                            class="text-left py-2 px-3 rounded-lg hover:bg-gray-100 transition duration-200 text-gray-800">
                            العربية
                        </button>
                        <button @click="switchLocale('fr'); toggleMobileMenu()"
                            class="text-left py-2 px-3 rounded-lg hover:bg-gray-100 transition duration-200 text-gray-800">
                            Français
                        </button>
                    </div>
                </div>

                <!-- Navigation Items -->
                <div class="space-y-2" v-if="route.name === 'inscription' || route.name === 'home'">
                    <button @click="router.push('/login'); toggleMobileMenu()"
                        class="w-full flex items-center space-x-3 py-3 px-4 rounded-lg hover:bg-gray-100 transition duration-200 text-left">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.75"
                            stroke="currentColor" class="w-5 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75" />
                        </svg>
                        <span class="text-gray-800">{{ $t('loginMsg') }}</span>
                    </button>
                </div>

                <!-- Admin Actions -->
                <div class="space-y-2" v-if="route.name === 'edit-info'">
                    <button @click="$emit('DeleteInfo'); toggleMobileMenu()"
                        class="w-full flex items-center space-x-3 py-3 px-4 rounded-lg hover:bg-red-50 transition duration-200 text-left text-red-600">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                        </svg>
                        <span>{{ $t('deleteInfo') }}</span>
                    </button>
                </div>

                <div class="space-y-2" v-if="isAdminRoute">
                    <button @click="Logout(); toggleMobileMenu()"
                        class="w-full flex items-center space-x-3 py-3 px-4 rounded-lg hover:bg-gray-100 transition duration-200 text-left">
                        <span class="text-gray-800">{{ $t('admin.logout') }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                        </svg>
                    </button>
                </div>

                <!-- Additional Navigation Links (Add your app's routes here) -->
                <div class="border-t border-gray-200 pt-4 space-y-2">
                    <button @click="router.push('/admin/edit'); toggleMobileMenu()" v-if="route.name !== 'admin-edit'"
                        class="w-full flex items-center space-x-3 py-3 px-4 rounded-lg hover:bg-gray-100 transition duration-200 text-left">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>

                        <span class="text-gray-800">{{ $t('admin_edit.menu_item') }}</span>
                    </button>

                    <button @click="router.push('/admin/dashboard'); toggleMobileMenu()"
                        v-if="route.name !== 'inscription' && route.name !== 'home'"
                        class="w-full flex items-center space-x-3 py-3 px-4 rounded-lg hover:bg-gray-100 transition duration-200 text-left">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-5 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z" />
                        </svg>
                        <span class="text-gray-800">{{ $t('admin_dashboard.title') }}</span>
                    </button>


                    <button v-if="adminStore.type == 's-admin' && route.name !== 'adminsList'"
                        @click="router.push('/admin/list'); toggleMobileMenu()"
                        class="w-full flex items-center space-x-3 py-3 px-4 rounded-lg hover:bg-gray-100 transition duration-200 text-left">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-6 text-primary">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
                        </svg>
                        <span class="text-gray-800">{{ $t('admin_create.admin_list') }}</span>
                    </button>


                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import Logo from './Logo.vue';
import { computed, defineEmits, ref } from 'vue';

import { useRoute, useRouter } from 'vue-router';
const route = useRoute();
const router = useRouter();

import { useAdminStore } from '@/stores/admin';
import { useSubscriberStore } from '@/stores/subscriber';


const adminStore = useAdminStore();
const subscriberStore = useSubscriberStore();

const emit = defineEmits([
    "DeleteInfo", "LoggingOut"
]);


const Logout = () => {

    localStorage.removeItem('auth_token');
    adminStore.$reset();
    subscriberStore.$reset();
    emit('LoggingOut');

};

const isAdminRoute = computed(() => {
    const adminRoutes = ['adminDashboard', 'admin-edit', 'adminsList', 'adminsCreate'];
    return adminRoutes.includes(route.name);
});

import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const switchLocale = (lang) => {
    locale.value = lang
}

// Mobile menu state
const showMobileMenu = ref(false);

const toggleMobileMenu = () => {
    showMobileMenu.value = !showMobileMenu.value;
};




</script>